import React, { useState } from 'react'
import { EntityAutocomplete } from '../../../Forms/SharedComponents/containers'
import { Field } from 'redux-form'
import { renderTextField } from '../../../Forms/fieldRenderers'
import { required, getNumericValidator } from '../../../Forms/fieldValidators'
import { Row, Col } from 'react-bootstrap'
import { FormControlLabel } from '@material-ui/core'
import Switch from '@material-ui/core/Switch'
import { COLORES } from '../../../../config/colores'
import MailOutlineIcon from '@material-ui/icons/MailOutline'
import moment from 'moment'

const numeric0to100 = getNumericValidator(1, 100)

export function NominacionDeCuposDialogView (props) {
  const { currentCupo, cargador, corredor } = props
  const [notificarCorredor, setNotificarCorredor] = useState(false)
  const [notificarCargador, setNotificarCargador] = useState(false)
  const [correoCargador, setCorreoCargador] = useState(null)
  const [correoCorredor, setCorreoCorredor] = useState(null)

  const handleNotificarCorredor = () => {
    if (notificarCorredor) {
      setNotificarCorredor(false)
      setCorreoCorredor(null)
      props.resetCorreoCorredor()
    } else {
      setNotificarCorredor(true)
      props.buscarCorreoCorredor(corredor).then((result) => {
        if (result) {
          setCorreoCorredor(result.correoElectronico)
        } else {
          setNotificarCorredor(false)
          props.resetCorreoCorredor()
        }
      })
    }
  }

  const handleNotificarCargador = async () => {
    if (notificarCargador) {
      setNotificarCargador(false)
      setCorreoCargador(null)
      props.resetCorreoCargador()
    } else {
      setNotificarCargador(true)
      props.buscarCorreoCargador(cargador).then((result) => {
        if (result) {
          setCorreoCargador(result.correoElectronico)
        } else {
          setNotificarCargador(false)
          props.resetCorreoCargador()
        }
      })
    }
  }

  moment.locale('ar-AR')
  const fecha = moment(currentCupo.fechaDeEmision).format('L')

  return (
    <>
      <Row>
        <Col md={5}>
          <EntityAutocomplete
            name='remitenteComercial'
            required
            label='Titular de Cupo'
            entity='cargador'
            placeholder='Cargador - 19999999991'
          />
        </Col>
        <Col md={5}>
          <EntityAutocomplete
            name='corredorComprador'
            required
            label='Corredor de Cupo'
            entity='corredor'
            placeholder='Corredor - 19999999991'
          />
        </Col>
        <Col md={2}>
          <Field
            name='cantidadNominada'
            label='Cantidad'
            type='number'
            component={renderTextField}
            validate={[required, numeric0to100]}
            placeholder=''
          />
        </Col>
      </Row>
      <hr />
      <div className='info-pie-dialogo' >
        <h6>
            Cereal:
          <span>
            {currentCupo.cereal}
          </span>
        </h6>
        <h6>
            Fecha:
          <span>
            {fecha}
          </span>
        </h6>
        <h6>
            Cantidad disponible:
          <span>
            {currentCupo.cantidadDisponible}
          </span>
        </h6>
      </div>
      <hr />
      <Row>
        <Col md={5}>
          {cargador && <FormControlLabel style={{ marginLeft: '2%' }} control={<Switch
            color='primary'
            name='notificarCargador'
            onChange={handleNotificarCargador}
            checked={notificarCargador}
          />}label='Notificar al Titular de Cupo' />}
        </Col>
        <Col md={7}>
          {cargador && <h6 style={{ textAlign: 'left', marginTop: '8px', color: COLORES.grey.mediumDark }}>
            <MailOutlineIcon style={{ marginRight: '2%', color: COLORES.grey.mediumDark }} />
            {correoCargador}
          </h6>}
        </Col>
      </Row>
      <Row>
        <Col md={5}>
          {corredor && <FormControlLabel style={{ marginLeft: '2%' }} control={<Switch
            color='primary'
            name='notificarCorredor'
            onChange={handleNotificarCorredor}
            checked={notificarCorredor}
          />}label='Notificar al Corredor de Cupo' />}
        </Col>
        <Col md={7}>
          {corredor && <h6 style={{ textAlign: 'left', marginTop: '8px', color: COLORES.grey.mediumDark }}>
            <MailOutlineIcon style={{ marginRight: '2%', color: COLORES.grey.mediumDark }} />
            {correoCorredor}
          </h6>}
        </Col>
      </Row>
    </>
  )
}
